export default {
  pt: {
    'shipments.descargaView.invoice': 'NF {{invoice}}',
    'shipments.descargaView.total': 'Total',
    'shipments.descargaView.loadError': 'Não foi possível carregar o quadro.',
    'shipments.descargaView.fleetStatus.unloading': 'Descarregando',
    'shipments.descargaView.fleetStatus.transit': 'Trânsito',
    'shipments.descargaView.fleetStatus.loading': 'Carregando',
    'shipments.descargaView.fleetStatus.available': 'Disponível',
    'shipments.descargaView.fleetStatus.onLeave': 'Folga',
    'shipments.descargaView.shipmentStatus.draft': 'Rascunho',
    'shipments.descargaView.shipmentStatus.awaitingHarvest': 'Aguardando colheita',
    'shipments.descargaView.shipmentStatus.loading': 'Carregando',
    'shipments.descargaView.shipmentStatus.awaitingInvoice': 'Aguardando nota',
    'shipments.descargaView.shipmentStatus.awaitingUnload': 'Aguardando descarga',
    'shipments.descargaView.shipmentStatus.unloading': 'Descarregando',
    'shipments.descargaView.shipmentStatus.released': 'Liberado',
    'shipments.descargaView.shipmentStatus.cancelled': 'Cancelada',
  },
  en: {
    'shipments.descargaView.invoice': 'Invoice {{invoice}}',
    'shipments.descargaView.total': 'Total',
    'shipments.descargaView.loadError': 'Could not load the board.',
    'shipments.descargaView.fleetStatus.unloading': 'Unloading',
    'shipments.descargaView.fleetStatus.transit': 'In transit',
    'shipments.descargaView.fleetStatus.loading': 'Loading',
    'shipments.descargaView.fleetStatus.available': 'Available',
    'shipments.descargaView.fleetStatus.onLeave': 'On leave',
    'shipments.descargaView.shipmentStatus.draft': 'Draft',
    'shipments.descargaView.shipmentStatus.awaitingHarvest': 'Awaiting harvest',
    'shipments.descargaView.shipmentStatus.loading': 'Loading',
    'shipments.descargaView.shipmentStatus.awaitingInvoice': 'Awaiting invoice',
    'shipments.descargaView.shipmentStatus.awaitingUnload': 'Awaiting unloading',
    'shipments.descargaView.shipmentStatus.unloading': 'Unloading',
    'shipments.descargaView.shipmentStatus.released': 'Released',
    'shipments.descargaView.shipmentStatus.cancelled': 'Cancelled',
  },
  es: {
    'shipments.descargaView.invoice': 'Factura {{invoice}}',
    'shipments.descargaView.total': 'Total',
    'shipments.descargaView.loadError': 'No se pudo cargar el tablero.',
    'shipments.descargaView.fleetStatus.unloading': 'Descargando',
    'shipments.descargaView.fleetStatus.transit': 'En tránsito',
    'shipments.descargaView.fleetStatus.loading': 'Cargando',
    'shipments.descargaView.fleetStatus.available': 'Disponible',
    'shipments.descargaView.fleetStatus.onLeave': 'Descanso',
    'shipments.descargaView.shipmentStatus.draft': 'Borrador',
    'shipments.descargaView.shipmentStatus.awaitingHarvest': 'Esperando cosecha',
    'shipments.descargaView.shipmentStatus.loading': 'Cargando',
    'shipments.descargaView.shipmentStatus.awaitingInvoice': 'Esperando factura',
    'shipments.descargaView.shipmentStatus.awaitingUnload': 'Esperando descarga',
    'shipments.descargaView.shipmentStatus.unloading': 'Descargando',
    'shipments.descargaView.shipmentStatus.released': 'Liberado',
    'shipments.descargaView.shipmentStatus.cancelled': 'Cancelada',
  },
}
